import React from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@material-ui/core"
import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import WarningRounded from '@material-ui/icons/WarningRounded';
import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { userFunctionActions } from "../../actions"
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  modalWrapper: {
    padding: "2rem",
    height: "100%",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: theme.palette.auxiliary.yellow.main,
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  titleWrapper: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    fontWeight: 600
  },
  description: {
    textAlign: "center",
    fontSize: 16
  },
  actions: {
    padding: theme.spacing(3)
  }
}));

export const DialogConfirmUser = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    dialogConfirmUser,
    loadingSubmitUser,
    selectedUser,
    selectedProfileType,
    userType,
  } = useSelector(state => state.userFunction)
  const { fields } = useSelector(state => state.multiAreaCascade);

  function handleNoButton() {
    dispatch(userFunctionActions.toggleDialogConfirmUser())
  }

  function handleYesButton() {
    const jsonData = {
      id: selectedUser.id,
      name: selectedUser.name,
      typeProfile: userType.filter(item => item.type === selectedProfileType)[0],
      businessUnitLocals: fields.filter(item => item.selectedBusinessUnit).map(item => item.selectedBusinessUnit)
    }

    dispatch(userFunctionActions.submitUser(jsonData));
  }

  return (
    <DialogResponsive open={dialogConfirmUser}>
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>
          <Grid item className={classes.iconWrapper}>
            <WarningRounded className={classes.warningIcon} />
          </Grid>
          <Grid item className={classes.titleWrapper}>
            <Typography variant="h4" component="h2" className={classes.title}>
              {t('atencao')}
            </Typography>
          </Grid>
          <Grid item>
            <p className={classes.description}>
              {t('voce_atribuiu_o_perfil')} {' '}
              <b>{userType.filter(item => item.type === selectedProfileType)[0]?.description}</b> 
              {' '}a{' '} 
              <b>{ selectedUser?.name }</b>. {' '}
              {t('deseja_confirmar')}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Grid container spacing={4} cols={2}>
          <Grid item>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleNoButton}
            >
              {t('nao')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              onClick={handleYesButton}
            >
              {t('sim')}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </DialogResponsive>
  )
}
